export function loginSucesso(nomeUsuario) {
    return { type: 'LOGIN_SUCCESS', nomeUsuario };
}


// WEBPACK FOOTER //
// ./src/redux/actions/autenticacaoAction.js